import type { ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import type { FontVariant } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import { Container, Title } from "./styles";

export type TitleSizes = "medium" | "large";

type TitleWithInfoSchema = {
    title: string;
    tooltip: ReactNode;
    size?: TitleSizes;
    fontVariant?: FontVariant;
    dataAutomation?: string;
};

export const TitleWithInfo = ({ title, tooltip, size, fontVariant, dataAutomation }: TitleWithInfoSchema) => {
    return (
        <Container
            size={size}
            data-automation={dataAutomation}
        >
            <Title
                size={size}
                fontVariant={fontVariant}
            >
                {title}
            </Title>

            {tooltip ? (
                <Tooltip
                    className="title-tooltip"
                    content={tooltip}
                    placement="top"
                    enabled={!!tooltip}
                >
                    <SWReactIcons
                        iconName="info"
                        size="xs"
                    />
                </Tooltip>
            ) : null}
        </Container>
    );
};
